import { Typographies } from '@/theme';

import { Box, Typography, styled } from '@mui/material';
export const UploadWidgetStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.white.dark,
  color: theme.palette.dark.dark_4,
  borderRadius: theme.spacing(1),
  height: 300,
  cursor: 'pointer',
}));

export const VideoPlayerStyled = styled('video')(({ theme }) => ({
  borderRadius: theme.spacing(1),
  height: 300,
  width: '100%',
}));

export const DeleteVideoTextStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  cursor: 'pointer',
  textAlign: 'center',
}));
export const InfoVideoTextStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.dark.dark_4,
  textAlign: 'center',
  fontSize: Typographies.FONT_SIZE_INPUTS,
}));

export const RootStyled = styled(Box)(({ theme }) => ({
  '& .react-thumbnail-generator': {
    width: '100%',
    height: '100%',
    '& img': {
      width: '100%',
    },
  },
}));
export const ThumbnailsContainerStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.dark.dark_4,
  background: theme.palette.white.dark,
  padding: theme.spacing(2),
  borderRadius: theme.spacing(0.5),
}));
